import {
  type CreateDestinationRequest,
  type DestinationListItem,
  DestinationListItemSchema,
  type DestinationListQuery,
  type DestinationListResponse,
  DestinationListResponseSchema,
  type UpdateDestinationRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Destinations master API (ADR-0041). Read endpoint is broad (used by
 * the lead form picker too); writes are admin/ops only.
 */
export const listDestinations = async (
  query: DestinationListQuery,
): Promise<DestinationListResponse> => {
  const { data } = await apiClient.get<unknown>('/destinations', { params: query });
  return DestinationListResponseSchema.parse(data);
};

export const getDestination = async (id: string): Promise<DestinationListItem> => {
  const { data } = await apiClient.get<unknown>(`/destinations/${id}`);
  return DestinationListItemSchema.parse(data);
};

export const createDestination = async (
  payload: CreateDestinationRequest,
): Promise<DestinationListItem> => {
  const { data } = await apiClient.post<unknown>('/destinations', payload);
  return DestinationListItemSchema.parse(data);
};

export const updateDestination = async (
  id: string,
  payload: UpdateDestinationRequest,
): Promise<DestinationListItem> => {
  const { data } = await apiClient.patch<unknown>(`/destinations/${id}`, payload);
  return DestinationListItemSchema.parse(data);
};

export const deleteDestination = async (id: string): Promise<void> => {
  await apiClient.delete(`/destinations/${id}`);
};

export const bulkDeleteDestinations = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/destinations/bulk-delete', { ids });
  return data;
};

export const bulkSetDestinationsStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/destinations/bulk-set-status', { ids, isActive });
  return data;
};
